import React from 'react';
import { Phone, Clock, MapPin, Zap } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-[#ECEC75] pt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-black rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-black rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left">
            <div className="inline-flex items-center gap-2 bg-black text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Clock className="w-4 h-4" />
              24/7 Emergency Service
            </div>
            
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
              Locked Out?
              <br />
              <span className="text-black">We're Here</span>
              <br />
              <span className="text-gray-700">To Help!</span>
            </h1>
            
            <p className="text-xl text-gray-700 mb-8 max-w-xl">
              Fast, reliable emergency lockout services across the Greater Toronto Area. 
              Our expert technicians are just a phone call away.
            </p>

            {/* CTA Button */}
            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a href={companyInfo.phoneLink}>
                <Button className="bg-black hover:bg-gray-800 text-white px-8 py-6 text-xl font-bold flex items-center gap-3 transition-all hover:scale-105 shadow-2xl">
                  <Phone className="w-6 h-6 animate-pulse" />
                  CALL US NOW
                </Button>
              </a>
              <div className="flex items-center gap-2 text-gray-900">
                <span className="text-2xl font-bold">{companyInfo.phone}</span>
              </div>
            </div>

            {/* Quick Info */}
            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-lg">
                <Zap className="w-5 h-5 text-yellow-600" />
                <span className="font-semibold text-gray-900">Fast Response</span>
              </div>
              <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-lg">
                <MapPin className="w-5 h-5 text-yellow-600" />
                <span className="font-semibold text-gray-900">All GTA</span>
              </div>
              <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-lg">
                <span className="font-bold text-yellow-600">$20</span>
                <span className="font-semibold text-gray-900">Service Fee</span>
              </div>
            </div>
          </div>

          {/* Right Content - Logo Display */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-black/10 rounded-full blur-3xl scale-150"></div>
              <img 
                src={companyInfo.logo} 
                alt="Lockout Bros Emergency Services" 
                className="relative w-80 md:w-96 lg:w-[450px] h-auto drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
